<template>
    <div class="item-question-images">
        <div class="d-flex flex-column"
             :class="optionsLocation">
            <div class="p-0 pe-4 flex-grow-1">
                <div class="d-flex flex-row">
                    <label v-if="numberContent != ''" class="text-color-number mb-1">
                        {{ numberContent }}
                    </label>
                    <label class="text-color-questions mb-1 ps-2"
                           v-html="labelContent">
                    </label>
                </div>
                <div
                    v-if="question.additionalInfo"
                    class="form-input-help mb-1"
                    v-html="question.additionalInfo"
                >
                </div>
            </div>
            <div class="p-0">
                <image-input :field-id="question.questionId"
                             :name="'question_' + TYPE_FIELD_ID + '_' + question.questionId"
                             :other-text="translateLabels.textOther"
                             :question="question"
                             :type="question.multipleSelectImage ? 'checkbox' : 'radio'"
                             :type-field-id="TYPE_FIELD_ID"
                             :url-image="urlRouteSymfonyOrS3 + url_link"
                             :validation="validationRules"
                             @invalidInput="error = true"
                             @validInput="error = false"
                             @message="messageError = $event"
                />
            </div>
        </div>
        <p v-if="error" class="has-error-msg">{{ messageError }}</p>
    </div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import ImageInput from "../components/image-input.vue";

// INITIALIZE STORE & COMPOSABLES
const playerStore = usePlayerStore();

// PROPS & EMITS
const props = defineProps({
    enumeration: {
        type: Number,
        required: false,
        default: 0,
    },
    question: {
        type: Object,
        required: true,
    },
    showNumbering: {
        type: Boolean,
        required: false,
        default: false,
    },
    store: {
        type: Object,
        required: true
    },
    translateLabels: {
        type: Object,
        required: true,
    },
    TYPE_FIELD_ID: {
        type: Number,
        required: true,
    },
});

// REACTIVE VARIABLES
const url_link = ref('images_variables/forms/');
const error = ref(false);
const messageError = ref('');

// COMPUTED PROPERTIES
const labelContent = computed(() => {
    const label = [];

    if (Boolean(props.question.required)) {
        label.push(`* ${props.question.description}`);
    } else {
        label.push(props.question.description);
    }

    return label.join(' ');
});

const numberContent = computed(() => {
    const label = [];

    if (Boolean(props.showNumbering)) {
        label.push(`${String(props.enumeration).padStart(2, '0')}.`);
    }

    return label.join(' ');
});

const optionsLocation = computed(() => {
    if (props.question.optionLocation == 'left') {
        return 'flex-md-row align-items-lg-center';
    }
    return '';
});

const urlRouteSymfonyOrS3 = computed(() => {
    return playerStore.getPathLocalOrServer;
});

const validationRules = computed(() => {
    const rules = {
        required: false,
    };
    if (props.question.required) {
        rules.required = true;
    }

    return rules;
});

// METHODS

// LIFECYCLE HOOKS
onMounted(() => {
    if (props.question.answer === '') {
        props.question.answer = [];
    }
});
</script>
